import GridItemList from 'components/GridItemList.tsx';
import { FormattedDate } from 'components/misc/FormattedDate';
import { EmployeeNameLink } from 'components/record-chip/RecordLink';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BankTransactionDetails } from 'types/bank-transfers.ts';

// `entity-link` takes the detail row's link colour (`GridItemList`).
const EMPLOYEE_LINK_CLASS = 'entity-link w-fit whitespace-nowrap no-underline hover:underline';

type BankTransferInformationProps = {
    bankTransfer: BankTransactionDetails;
};

const BankTransferInformation: React.FC<BankTransferInformationProps> = ({ bankTransfer }) => {
    const information = [
        {
            content: <FormattedDate value={bankTransfer.entryBookingDate} fallback="" />,
            label: <FormattedMessage id="bank-transfers.payment-date" />,
        },
        { content: bankTransfer.entryTransactionId, label: <FormattedMessage id="bank-transfers.transaction-id" /> },
        {
            content: bankTransfer.bankStatementNumber || '-',
            label: <FormattedMessage id="bank-transfers.bank-statement-number" />,
        },
        { content: bankTransfer.accountOwnerName, label: <FormattedMessage id="bank-transfers.receiver-name" /> },
        { content: bankTransfer.accountIban, label: <FormattedMessage id="bank-transfers.receiver-iban" /> },
        { content: bankTransfer.entryDebtorName, label: <FormattedMessage id="bank-transfers.sender-name" /> },
        {
            content: <>{bankTransfer.entryAmountCurrencyTypeCode}</>,
            label: <FormattedMessage id="bank-transfers.currency" />,
        },
        { content: bankTransfer.entryAmount, label: <FormattedMessage id="bank-transfers.amount" /> },
        { content: bankTransfer.entryDescription, label: <FormattedMessage id="bank-transfers.description" /> },
        {
            content: bankTransfer.entryReferenceNumber || '-',
            label: <FormattedMessage id="bank-transfers.reference-number" />,
        },
        {
            content: <FormattedDate value={bankTransfer.createdAt} fallback="" />,
            label: <FormattedMessage id="bank-transfers.uploaded-at" />,
        },
        {
            content: bankTransfer.createdBy?.id ? (
                <EmployeeNameLink
                    className={EMPLOYEE_LINK_CLASS}
                    to={`/employee/${bankTransfer.createdBy.id}`}
                    entity={bankTransfer.createdBy}
                />
            ) : (
                bankTransfer.createdBy?.name || ''
            ),
            label: <FormattedMessage id="bank-transfers.uploaded-by" />,
        },
        {
            content: <FormattedDate value={bankTransfer.lastModifiedAt} fallback="" />,
            label: <FormattedMessage id="bank-transfers.modified-at" />,
        },
        {
            content: bankTransfer.lastModifiedBy?.id ? (
                <EmployeeNameLink
                    className={EMPLOYEE_LINK_CLASS}
                    to={`/employee/${bankTransfer.lastModifiedBy.id}`}
                    entity={bankTransfer.lastModifiedBy}
                />
            ) : (
                bankTransfer.lastModifiedBy?.name || ''
            ),
            label: <FormattedMessage id="bank-transfers.modified-by" />,
        },
    ];

    return <GridItemList titleId="bank-transfers.information" size={12} data={information} />;
};

export default BankTransferInformation;
